module.exports = {
    yearInSeconds: 365 * 24 * 60 * 60,
    yearInMilliseconds: 365 * 24 * 60 * 60 * 1000,
    minuteInMilliseconds: 60 * 1000,
    dayInMilliSeconds: 24 * 60 * 60 * 1000
};
